<template>
    <div name="addition-info" class="addition-info">
        <close-button
            @close="onClose"
        />
        <img src="../../../assets/contract_step_4.png" class="step" />
        <span class="title" style="margin-top: 30px;">요양비 구매 조건 확인에 활용됩니다</span>
        <span class="text1">구매 주기를 놓치지 않도록, <br>솔닥 컨시어지가 챙겨드립니다!</span>
        <div class="line"></div>
        <span class="title">구매 가능일 입력</span>
        <span v-if="draftProfile.diabetes_type === 'TYPE1'" class="text1" style="color: var(--Gray-100, #1E1E1E);">전극과 소모성재료 날짜는 <span style="color: #184FA1;">공단에서 문자로 안내받은 날짜</span>로 입력해 주세요. <br>정확한 날짜를 모르겠다면 <span style="font-weight: 600;">'모름'</span>에 체크해주세요.</span>
        <span v-else-if="draftProfile.diabetes_type === 'SELF_CATHETER'" class="text1" style="color: var(--Gray-100, #1E1E1E);">카테터 날짜는 <span style="color: #184FA1;">공단에서 문자로 안내받은 날짜</span>로 입력해 주세요. <br>정확한 날짜를 모르겠다면 <span style="font-weight: 600;">'모름'</span>에 체크해주세요.</span>
        
        <div style="width: 100%;" v-if="draftProfile.diabetes_type !== 'SELF_CATHETER'">
            <span class="text-20-400-1E1E1E" style="margin-top: 20px;">전극</span>
                <div class="row" style="margin-top: 16px;">
                    <check-box
                        :checked="firstCheck"
                        @onClick="() => firstCheck = !firstCheck"
                    />
                    <span class="text-18-400-1E1E1E" style="margin-left: 16px;">최초 처방</span>

                    <check-box
                        style="margin-left: 32px;"
                        :checked="sensorDontKnowCheck"
                        @onClick="() => sensorDontKnowCheck = !sensorDontKnowCheck"
                    />
                    <span class="text-18-400-1E1E1E" style="margin-left: 16px;">모름</span>
                </div>

                <div v-if="!firstCheck && !sensorDontKnowCheck" class="input-calendar-wrapper" style="margin-top: 9px;">
                    <input
                        class="input-calendar"
                        ref="dateInput1"
                        v-model="electrode_date"
                        v-focus-background
                        placeholder="날짜를 선택해주세요"
                        readonly
                        @click="openDatePicker1"
                    />
                    <span v-if="electrode_date" class="clear-btn" @click.stop="clearElectrodeDate">×</span>
                </div>

                <date-picker-modal
                    v-if="showDatePicker1"
                    :initialDate="electrode_date"
                    @onClose="closeDatePicker1"
                    @onConfirm="confirmDatePicker1"
                />


                <span class="text-20-400-1E1E1E" style="margin-top: 20px;">소모성 재료</span>
                <div class="row" style="margin-top: 16px;">
                    <check-box 
                        :checked="itemDontKnowCheck"
                        @onClick="() => itemDontKnowCheck = !itemDontKnowCheck"
                    />
                    <span class="text-18-400-1E1E1E" style="margin-left: 16px;">모름</span>
                </div>
                <div v-if="!itemDontKnowCheck" class="input-calendar-wrapper" style="margin-top: 9px;">
                    <input
                        class="input-calendar"
                        ref="dateInput2"
                        v-model="expendable_date"
                        v-focus-background
                        placeholder="날짜를 선택해주세요"
                        readonly
                        @click="openDatePicker2"
                    />
                    <span v-if="expendable_date" class="clear-btn" @click.stop="clearExpendableDate">×</span>
                </div>
                <date-picker-modal
                    v-if="showDatePicker2"
                    :initialDate="expendable_date"
                    @onClose="closeDatePicker2"
                    @onConfirm="confirmDatePicker2"
                />
        </div>
        <div style="width: 100%; margin-top: 20px;" v-else>
            <span class="text-20-400-1E1E1E">카테터</span>
                <div class="row" style="margin-top: 16px;">
                    <check-box 
                        :checked="catheterDontKnowCheck"
                        @onClick="() => catheterDontKnowCheck = !catheterDontKnowCheck"
                    />
                    <span class="text-18-400-1E1E1E" style="margin-left: 16px;">모름</span>
                </div>
                <div v-if="!catheterDontKnowCheck" class="input-calendar-wrapper" style="margin-top: 9px;">
                    <input
                        class="input-calendar"
                        ref="dateInput2"
                        v-model="catheter_date"
                        v-focus-background
                        placeholder="날짜를 선택해주세요"
                        readonly
                        @click="openDatePicker3"
                    />
                    <span v-if="catheter_date" class="clear-btn" @click.stop="clearCatheterDate">×</span>
                </div>
                <date-picker-modal
                    v-if="showDatePicker3"
                    :initialDate="catheter_date"
                    @onClose="closeDatePicker3"
                    @onConfirm="confirmDatePicker3"
                />
        </div>
        
        <div class="bold-line"></div>
        <span class="text-20-400-1E1E1E" >경감 대상 선택</span>
         <radio-button-list 
            style="margin-top: 16.5px;"
            :labelList="['해당없음', '기초생활수급자', '차상위계층']"
            :selectedIndex="selectedSaleType"
            @select="selectSaleType"
            ref="type"
        />
        
        <div style="width: 100%;" v-if="draftProfile.diabetes_type !== 'SELF_CATHETER'">
            <div class="bold-line"></div>
            <span class="text-20-400-1E1E1E">인슐린펌프 사용 여부</span>
            <span class="text1" style="color: #1E1E1E;">만 19세 미만 미니메드 780G 인슐린펌프 사용자의 경우 공단 지원금이 다를 수 있습니다.</span>
            <div class="row" style="margin-top: 16px; margin-bottom: 124px;">
                <check-box 
                    :checked="useAutoInjector"
                    @onClick="() => useAutoInjector = !useAutoInjector"
                />
                <span class="text-18-400-1E1E1E" style="margin-left: 16px;">미니메드 780G 사용</span>            
            </div>
        </div>

        <div class="footer-button-area">
            <div class="buttons" style="margin-top: 8px;">
                <button class="button1" @click="prev">이전</button>
                <button class="button2" @click="next">제출하기</button>
            </div>
        </div>
    </div>
</template>

<script>
import CloseButton from '@/components/atoms/CloseButton';
import {mapState} from 'vuex';
import CheckBox from '@/components/atoms/CheckBox.vue'
import RadioButtonList from '@/components/molecules/RadioButtonList';
import DatePickerModal from '@/components/modals/DatePickerModal';
import Constant from '@/constant';
import focusBackground from '@/components/directives/focusBackground';
export default {
    name: 'additionInfo',
    computed: mapState(['delegateWithAddition', 'draftProfile']),
    components: {
        CloseButton,
        CheckBox,
        RadioButtonList,
        DatePickerModal
    },
    directives: {
        focusBackground
    },
    data() {
        return {
            firstCheck: false,
            sensorDontKnowCheck: false,
            itemDontKnowCheck: false,
            catheterDontKnowCheck: false,
            selectedSaleType: 0,
            useAutoInjector: false,
            expendable_date: null,
            electrode_date: null,
            showDatePicker1: false,
            showDatePicker2: false,
            showDatePicker3: false,
            catheter_date: null
        }
    },
    methods: {
         errorFocus: function(field)
        {
            this.$refs[field].style.border = '1.5px solid var(--Semantic-01_Red, #FF000F)';

            const offsetTop = this.$refs[field].offsetTop;
                window.scrollTo({
                    top: offsetTop - 50, // 50px 위로 조정
                    behavior: 'smooth'
            });
        },
         normalizeToYYYYMMDDOrKeep: function (input) {
            var original = (input == null) ? "" : String(input);
            var s0 = original.trim();
            if (!s0) return original;

            // 숫자와 구분자(.,-)만 남기기
            var s = s0.replace(/[^\d.-]/g, "");

            // 1) 숫자만: YYYYMMDD
            var digits = s.replace(/[.-]/g, "");
            if (/^\d{8}$/.test(digits)) {
                var y = digits.slice(0, 4);
                var m = digits.slice(4, 6);
                var d = digits.slice(6, 8);
                var r1 = this.validateAndFormatStrict(y, m, d);
                return (r1 !== null && r1 !== undefined) ? r1 : original;
            }

            // 2) 연도 + 나머지: 2025-0101, 202501.01, 2025.01.01, 2025-01-01 등
            //    (불완전 입력: 2025-1 / 2025-01-1 / 2025-01-0 등은 보정하지 않고 그대로)
            var yearMatch = s.match(/^(\d{4})[.-]?(.+)$/);
            if (yearMatch) {
                var y2 = yearMatch[1];
                var rest = yearMatch[2];

                // rest가 "1" 이거나 "01-1" 같은 불완전이면 그대로 반환하기 위해
                // 월/일을 '정확히 2자리'로만 인정한다.
                var parts = rest.split(/[.-]+/).filter(Boolean);

                // 케이스: 2025-01-01, 2025.01.01
                if (parts.length >= 2 && /^\d{2}$/.test(parts[0]) && /^\d{2}$/.test(parts[1])) {
                var r2 = this.validateAndFormatStrict(y2, parts[0], parts[1]);
                return (r2 !== null && r2 !== undefined) ? r2 : original;
                }

                // 케이스: 2025-0101, 202501.01 (연도 뒤 나머지 숫자가 정확히 4자리면 MMDD로 인정)
                var restDigits = rest.replace(/[^\d]/g, "");
                if (/^\d{4}$/.test(restDigits)) {
                var m2 = restDigits.slice(0, 2);
                var d2 = restDigits.slice(2, 4);
                var r3 = this.validateAndFormatStrict(y2, m2, d2);
                return (r3 !== null && r3 !== undefined) ? r3 : original;
                }
            }

            // 그 외는 그대로
            return original;
        },
        /* ---------- helpers ---------- */
        validateAndFormatStrict: function (y, m, d) {
            if (!/^\d{4}$/.test(String(y))) return null;
            if (!/^\d{2}$/.test(String(m))) return null;
            if (!/^\d{2}$/.test(String(d))) return null;

            var year = Number(y);
            var month = Number(m);
            var day = Number(d);

            if (year < 1900 || year > 2100) return null;
            if (month < 1 || month > 12) return null;

            var lastDay = new Date(year, month, 0).getDate();
            if (day < 1 || day > lastDay) return null;

            return y + "-" + m + "-" + d;
        },
        isValidYYYYMMDD: function (dateStr) {
            if (typeof dateStr !== "string") return false;

            // 형식 체크
            if (!/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return false;

            var parts = dateStr.split("-");
            var year = Number(parts[0]);
            var month = Number(parts[1]);
            var day = Number(parts[2]);

            // 월 범위
            if (month < 1 || month > 12) return false;

            // 해당 월의 마지막 날 (윤년 포함)
            var lastDay = new Date(year, month, 0).getDate();

            // 일 범위
            if (day < 1 || day > lastDay) return false;

            return true;
        },
        onClose: function()
        {
            this.$emit('onClose');
        },
        openDatePicker1: function()
        {
            this.showDatePicker1 = true;
        },
        closeDatePicker1: function()
        {
            this.showDatePicker1 = false;
        },
        confirmDatePicker1: function(date)
        {
            this.electrode_date = date;
            this.showDatePicker1 = false;
        },
        openDatePicker2: function()
        {
            this.showDatePicker2 = true;
        },
        closeDatePicker2: function()
        {
            this.showDatePicker2 = false;
        },
        confirmDatePicker2: function(date)
        {
            this.expendable_date = date;
            this.showDatePicker2 = false;
        },
        openDatePicker3: function()
        {
            this.showDatePicker3 = true;
        },
        closeDatePicker3: function()
        {
            this.showDatePicker3 = false;
        },
        confirmDatePicker3: function(date)
        {
            this.catheter_date = date;
            this.showDatePicker3 = false;
        },
        clearElectrodeDate: function()
        {
            this.electrode_date = null;
        },
        clearExpendableDate: function()
        {
            this.expendable_date = null;
        },
        clearCatheterDate: function()
        {
            this.catheter_date = null;
        },
        selectSaleType (type) {
            this.selectedSaleType = type;
        },
        prev() {
            this.$emit('prev', 3)
        },  
        next() {
            // validation check 
            this.delegateWithAddition.additional_info.is_injection_insulin = this.useAutoInjector;
            this.delegateWithAddition.additional_info.person_type = this.selectedSaleType === 0 ? null : this.selectedSaleType === 1 ? 'NATIONAL_BASIC' : this.selectedSaleType === 2 ? 'LOW_INCOME' : null;

            this.delegateWithAddition.additional_info.electrode_date = this.electrode_date;
            this.delegateWithAddition.additional_info.expendable_date = this.expendable_date;
            this.delegateWithAddition.additional_info.catheter_date = this.catheter_date;


            if(this.delegateWithAddition.additional_info.electrode_date  === '')
            {
                this.delegateWithAddition.additional_info.electrode_date = null;
            }
            if(this.delegateWithAddition.additional_info.expendable_date === '')
            {
                this.delegateWithAddition.additional_info.expendable_date = null;
            }
            if(this.delegateWithAddition.additional_info.catheter_date === '')
            {
                this.delegateWithAddition.additional_info.catheter_date = null;
            }


            this.delegateWithAddition.additional_info.electrode_first = this.firstCheck;
            this.$emit('submit')
        }
    },
    watch: {
        firstCheck: function()
        {
            this.electrode_date = null;
        },
        sensorDontKnowCheck: function()
        {
            this.electrode_date = null;
        },
        itemDontKnowCheck: function()
        {
            this.expendable_date = null;
        },    
        catheterDontKnowCheck: function()
        {
            this.catheter_date = null;
        }, 
        expendable_date: function()
        {
            this.expendable_date = this.normalizeToYYYYMMDDOrKeep(this.expendable_date)
        },
        electrode_date: function()
        {
            this.electrode_date = this.normalizeToYYYYMMDDOrKeep(this.electrode_date)
        },
        catheter_date: function()
        {
            this.catheter_date = this.normalizeToYYYYMMDDOrKeep(this.catheter_date)
        }
    }
}
</script>

<style scoped>
    .addition-info {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        box-sizing: border-box;
        padding: 16px;
    }
    @media (min-width: 600px) {
        .addition-info {
            width: 600px;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-direction: column;
            box-sizing: border-box;
            padding: 15px;
        }
    }
    .step {
        width: 100%;
        max-width: 600px;
    }
    .title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px; /* 108.333% */

    }
    .text1 {
        color: #184FA1;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        margin-top: 16px;
    }
    .line {
        width: 100%;
        height: 1px;
        background: #EDEEF0;
        margin: 20px 0 20px 0;
    }
    .text-20-400-1E1E1E {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .text-20-600-1E1E1E {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .text-18-400-1E1E1E {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .row {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .input-calendar-wrapper {
        position: relative;
        width: 100%;
    }
    .input-calendar {
        border: 0;
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        cursor: pointer;
        height: 48px;
        padding: 16px 40px 16px 15px;
        box-sizing: border-box;
        width: 100%;
    }
    .clear-btn {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: #A3AAB6;
        font-size: 24px;
        font-weight: 300;
    }
    .input-calendar::placeholder {
        color: var(--Gray-50, #A3AAB6);
    }
    @supports (-webkit-touch-callout: none) {
        input[type="date"] {
            height: 48px;
            width: calc(100% - 32px);
            max-width: calc(568px);
            line-height: 48px;   /* 🔥 핵심 */
            padding: 0 12px;
            box-sizing: border-box;
            font-size: 18px;     /* iOS 줌 방지 + 안정화 */
        }
    }

    .bold-line{
        height: 8px;
        width: 100%;
        background: var(--Gray-sub-color1, #F3F5F8);        
        margin: 20px 0 20px 0;
    }
    .footer-button-area {
        position: fixed;
        bottom: 0;
        width: calc(100% - 32px);
        max-width: 568px;
        background: linear-gradient(0deg, #FFF 0%, rgba(255, 255, 255, 0.00) 255.33%);
        z-index: 9999;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 10px 0 28px 0;
        box-sizing: border-box;
    }
    .buttons {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .button1{
        height: 56px;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        width: 48%;
        max-width: 247px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 0;
        cursor: pointer;
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .button2 {
        height: 56px;
        flex-shrink: 0;
        border-radius: 6px;
        background: #184FA1;
        width: 48%;
        max-width: 247px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border: 0;
        color: var(--Gray-primary-color2, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/contract/AdditionInfo.vue